{
  "Accessibility menu": "Tillgänglighetsmeny",
  "Reset settings": "Nollställ inställningar",
  "Close": "Stäng",
  "Content adjustments": "Anpassa innehåll",
  "Navigation adjustments": "Anpassa navigering",
  "Align Left": "Vänsterjustera",
  "Adjust Font Size": "Justera textstorlek",
  "Highlight Title": "Framhäv titel",
  "Highlight Links": "Framhäv länkar",
  "Readable Font": "Läsbart teckensnitt",
  "Colour adjustments": "Anpassa färger",
  "Dark Contrast": "Mörk kontrast",
  "Light Contrast": "Ljus kontrast",
  "High Contrast": "Hög kontrast",
  "High Saturation": "Hög mättnad",
  "Low Saturation": "Låg mättnad",
  "Monochrome": "Monokrom",
  "Tools": "Verktyg",
  "Reading Guide": "Läslinjal",
  "Stop Animations": "Hindra animationer",
  "Big Cursor": "Stor muspekare",
  "Increase Font Size": "Öka textstorlek",
  "Decrease Font Size": "Minska textstorlek",
  "Letter Spacing": "Teckenavstånd",
  "Line Height": "Radhöjd",
  "Font Weight": "Teckensnitt tjocklek",
  "Dyslexia Font": "Dyslektiskt teckensnitt",
  "Language": "Språk",
  "Accessibility widget": "Öppna tillgänglighetsmeny",
  "Accessibility Profiles": "Tillgänglighetsprofiler",
  "Cognitive Disability": "Kognitiv funktionsnedsättning",
  "Seizure Safe": "Anfallssäker",
  "Accessibility statement": "Tillgänglighetsutlåtande"
}